<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vVQVEQ/tc-custom/9781504082860.jpg?1706271605631" alt="This image is the cover for the book Through Her Eyes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Through Her Eyes
      </h1>
      <p class="bookDescription body article font2">
        <p>“NJ Moss knows how to get inside your head with a story that will leave you reeling in its wake! Work of a genius.” —Amazon review<br/>  <br/><b>This compelling new psychological thriller from the bestselling author of <i>The Second Wife</i> begs the question: <i>How far would you go to save a stranger?</i></b><br/>  <br/> Jess spends most of her time alone to hide her obsession: prowling the streets, looking into other people’s homes, sneaking glimpses of their private lives . . .<br/>  <br/> When Jess witnesses a man standing at the sink, washing blood off his hands and a woman, nearby, with a dejected expression, a simmering anger is unleashed. She may be a loner, but Jess won’t stand by when another woman is being abused, so she starts to make plans for a rescue. But what you see through a window frame is only ever part of the story, and Jess may be about to learn that you can’t always trust what you think you’ve seen . . .</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        NJ Moss
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3fa666d5